import { React, dtos, serviceClient, ui, observer, observable, moment, _, Link, uuid, selectFilter, shared, humanFileSize, makeObservable } from "../common"
import { useEffect, useState } from "react"
import { DashboardHomeData, GetDashboardHome } from "../dtos";
import CustomerSpendChart from "./charts/spend-chart";

export default function DashboardHome() {
    const [startDate, setStartDate] = useState(moment().startOf("week"));
    const [endDate, setEndDate] = useState(moment().endOf("week"));
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<DashboardHomeData>(null);

    function setDateRange(range) {
        setStartDate(range[0].startOf("day"));
        setEndDate(range[1].endOf("day"));
    }

    useEffect(function onDatesChanged() {
        refresh();
    }, [startDate, endDate])

    function refresh() {
        if (isLoading) return;
        setData(null);
        setIsLoading(true);
        serviceClient.get(new GetDashboardHome({
            accountId: shared.accountId,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString()
        })).then(function (h) {
            setData(h);
        }).finally(function () {
            setIsLoading(false);
        })
    }

    return <div>
        <ui.Form layout="inline" style={{ marginBottom: 8 }}>
            <ui.Form.Item>
                <ui.Space>
                    <ui.DatePicker.RangePicker
                        disabled={isLoading}
                        size="large"
                        ranges={{
                            "Yesterday": [moment().add(-1, "days").startOf("day"), moment().add(-1, "days").endOf("day")],
                            "Today": [moment().startOf("day"), moment().endOf("day")],
                            "This Week": [moment().startOf("week"), moment().endOf("week")],
                            "This Month": [moment().startOf("month"), moment().endOf("month")],
                        }}
                        format={"LL"}
                        value={[startDate, endDate]}
                        onChange={ev => setDateRange(ev)} />
                    <ui.Button disabled={isLoading} size="large" icon={<i className={`fa fa-refresh ${isLoading && " fa-spin"}`} />} onClick={refresh} />
                </ui.Space>
            </ui.Form.Item>
        </ui.Form>
        {isLoading && <div style={{display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px"}}>
            <ui.Spin />
        </div>}
        {data && <div>
            <CustomerSpendChart data={data.customerSpends} />
        </div>}
    </div>
}